exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#paypal DL{width:100%;display:flex;flex-flow:row;flex-wrap:wrap}#paypal DL DT{padding:.5em 0;margin:0;text-align:right;flex:1 0 30%}#paypal DL DT:after{content:\":\"}#paypal DL DD{padding:.5em 0;margin:0;padding-left:2em;text-align:left;flex:1 0 calc(70% - 2em);font-weight:700}#paypal .results{display:flex;flex-flow:column;align-items:center}#paypal .results-icon{flex:1;padding:1em;max-width:10em;width:50vw}#paypal #paypal-button-container{padding:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e0146694","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Paypal.vue
// module id = 62
// module chunks = 0